import React from "react";
import "./styling/DropDownMenu.css";

const DropDownMenu = (props) => {
  return <div className="drop-down-menu">{props.children}</div>;
};

export default DropDownMenu;
